<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "API Hotel Search Routing List",
      items: [
        {
          text: "Hotel",
          href: "/",
        },
        {
          text: "Route List",
          active: true,
        },
      ],
      routes: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getRouteList();
  },
    computed: {
        filteredList() {
            return this.routes.filter(route => {
                return route.uuid.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
    async deleteWarning(route) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete Route!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(route);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getRouteList() {
      try {
        axios
          .get("/api/hotel/route_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.routes = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    deleteItem: function deleteItem(route) {
      var _this = this;
      axios
        .post("/api/hotel/route_delete/" + route.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.$swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: 'Successfully Delete Hotel API Search Route',
                  showConfirmButton: false,
                  timer: 1000
              });
              _this.getRouteList();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title">Responsive tables</h4>-->
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                      <th>Hotel Name</th>
                    <th>API Vendor</th>
                    <th>Allowed</th>
                    <th>Destination</th>
                    <th>Country Code</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(route,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="route.hotel_name!=null">{{route.hotel_name}}</td><td v-else>Null</td>
                    <td v-if="route.api_vendor_id!=null">{{route.api_vendor_id}}</td><td v-else>Null</td>
                    <td v-if="route.is_allowed!=null">{{route.is_allowed == 1 ? 'Yes' : 'No' }}</td><td v-else>Null</td>
                    <td v-if="route.destination!=null">{{route.destination}}</td><td v-else>Null</td>
                    <td v-if="route.country_code!=null">{{route.country_code}}</td><td v-else>Null</td>
                    <td><router-link :to="{ name: 'hotel_route_update', params: {uuid: route.uuid } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(route)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
